import {
    COMPOSE_ONLY_ATTACHMENT_CONTENT_START,
    COMPOSE_ONLY_ATTACHMENT_CONTENT_END,
} from 'owa-attachment-link-common';
import { isFeatureEnabled } from 'owa-feature-flags';

const contentToRemove = new RegExp(
    `<!--${COMPOSE_ONLY_ATTACHMENT_CONTENT_START}-->.*?<!--${COMPOSE_ONLY_ATTACHMENT_CONTENT_END}-->`,
    'gim'
);

export function removeComposeOnlyContent(html: string): string {
    if (html) {
        const processedHtml = html.replace(contentToRemove, '');
        return isFeatureEnabled('doc-link-errorAttribute')
            ? processedHtml.replace(/owa-btf-l-cmp-only=""/g, '')
            : processedHtml;
    } else {
        return html;
    }
}
